import React from 'react';
import One from '../layouts/one';
import Title from '../partials/title';
import { Animated } from 'react-animated-css';
import { preload } from '../../helpers';
import _ from 'lodash';

class Alumni extends React.Component {
    componentWillMount() { preload(this.props, true); }

    renderAlumni = (alumni, index) => {
        if (index % 2) {
            return (
                <Animated animationIn="fadeIn">
                    <div className="bg-whiteish" style={{ position: 'relative', overflow: 'hidden' }}>
                        <div className="d-flex flex-row w3-container w3-content pb-8 pt-8">
                            <div className="w-50">
                                <img alt="" className="w-100" src={alumni.Image} />
                            </div>
                            <div style={{ width: 40 }} />
                            <div className="w-100 d-flex flex-column justify-content-start">
                                <Title text={alumni.Name} />
                                <div className="margin-top hind">
                                    <div className="d-flex flex-row w-100">
                                        <span className="bold">Nationals Year</span>
                                        <span className="ml-auto toBold">{alumni.NationalsYear}</span>
                                    </div>
                                    <div className="d-flex flex-row w-100">
                                        <span className="bold">Team</span>
                                        <span className="ml-auto toBold">{alumni.Team}</span>
                                    </div>
                                    <div className="d-flex flex-row w-100">
                                        <span className="bold">Best Finish</span>
                                        <span className="ml-auto toBold">{alumni.BestFinish}</span>
                                    </div>
                                    <div className="d-flex flex-row w-100">
                                        <span className="bold">College</span>
                                        <span className="ml-auto toBold">{alumni.College}</span>
                                    </div>
                                    <div className="d-flex flex-row w-100">
                                        <span className="bold">Professional</span>
                                        <span className="ml-auto toBold">{alumni.Professional}</span>
                                    </div>
                                    <div className="w-100 margin-top">
                                        <p><span className="toBold">About me:</span> {alumni.Testimony}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <span className="super-hero-text black anton w-100 text-right block" style={{ position: 'absolute', bottom: -60, opacity: 0.05, }}>{_.first(alumni.Name.split(' ')).toUpperCase()}</span>
                    </div>
                </Animated>)
        } else {
            return (
                <Animated animationIn="fadeIn">
                    <div className="bg-white" style={{ position: 'relative', overflow: 'hidden' }}>
                        <span className="super-hero-text black anton w-100 text-left block" style={{ position: 'absolute', bottom: -60, opacity: 0.05, }}>{_.first(alumni.Name.split(' ')).toUpperCase()}</span>
                        <div className="d-flex flex-row w3-container w3-content pb-8 pt-8" style={{ zIndex: 1 }}>
                            <div className="w-100 d-flex flex-column justify-content-start">
                                <Title text={alumni.Name} />
                                <div className="margin-top hind">
                                    <div className="d-flex flex-row w-100">
                                        <span className="bold">Nationals Year</span>
                                        <span className="ml-auto toBold">{alumni.NationalsYear}</span>
                                    </div>
                                    <div className="d-flex flex-row w-100">
                                        <span className="bold">Team</span>
                                        <span className="ml-auto toBold">{alumni.Team}</span>
                                    </div>
                                    <div className="d-flex flex-row w-100">
                                        <span className="bold">Best Finish</span>
                                        <span className="ml-auto toBold">{alumni.BestFinish}</span>
                                    </div>
                                    <div className="d-flex flex-row w-100">
                                        <span className="bold">College</span>
                                        <span className="ml-auto toBold">{alumni.College}</span>
                                    </div>
                                    <div className="d-flex flex-row w-100">
                                        <span className="bold">Professional</span>
                                        <span className="ml-auto toBold">{alumni.Professional}</span>
                                    </div>
                                    <div className="w-100 margin-top">
                                        <p><span className="toBold">About me:</span> {alumni.Testimony}</p>
                                    </div>
                                </div>
                            </div>
                            <div style={{ width: 40 }} />
                            <div className="w-50">
                                <img alt="" className="w-100" src={alumni.Image} />
                            </div>
                        </div>
                    </div>
                </Animated>
            )
        }
    }
    render() {
        const { alumnis } = this.props;
        return (
            <One nbs="alumni" bi="alumni3.png">
                <section className="bg-white">
                    <div style={{ height: 600, zIndex: 1, }} className="d-flex flex-column justify-content-center">
                        <Animated animationIn="fadeInLeft" className="w-100 align-self-center w3-container w3-content" style={{ zIndex: 1 }}>
                            <h1 className="hero-text anton white text-left">ALUMNI</h1>
                            <p className="white hind">Challenge Sports believes the small-sided game helps create a foundation for all soccer players. The many different aspects the game brings, help in the growth and development of players in their transition to the larger field. Our 3v3 Alumni page spotlights players that have achieved the highest levels of soccer, and who credit some of their success to their participation and love for the small-sided game.</p>
                            <p className="white hind text-center toUpper toBold">Will you be the next Alumni?</p>
                        </Animated>
                    </div>
                    {alumnis && alumnis.map((alumni, index) => this.renderAlumni(alumni, index))}
                </section>
            </One>
        );
    }
}

export default Alumni;



// WEBPACK FOOTER //
// ./src/components/alumni/index.js